import { gql } from '@apollo/client';

// Documentos GraphQL de la pantalla admin "Prometeo": los contactos de RRHH que ven el
// panel de su empresa en /company. El gestor no es un rol aparte sino un CLIENT con el flag
// `is_org_manager`, por eso los selectores del modal reusan la query `users` de siempre.

export const ORGANIZATION_MANAGERS = gql`
  query OrganizationManagers($search: String) {
    organizationManagers(search: $search) {
      id
      full_name
      email
      phone
      photo
      is_online
      membership_status
      organization_joined_at
      organization {
        id
        name
        is_active
        members_count
      }
    }
  }
`;

// Empresas disponibles para el selector del modal (lista corta, sin paginación en la UI).
export const ORG_MANAGER_ORGANIZATIONS = gql`
  query OrgManagerOrganizations {
    organizations(first: 100, page: 1) {
      data {
        id
        name
        is_active
        is_default
        members_count
      }
    }
  }
`;

// Miembros de una empresa: candidatos a ser designados gestores.
export const ORG_MANAGER_CANDIDATES = gql`
  query OrgManagerCandidates($organization_id: [Int!]) {
    users(role: CLIENT, organization_id: $organization_id, first: 500, page: 1) {
      data {
        id
        full_name
        email
        is_org_manager
      }
    }
  }
`;

export const SET_ORGANIZATION_MANAGERS = gql`
  mutation SetOrganizationManagers($organization_id: ID!, $user_ids: [ID!]!, $is_manager: Boolean!) {
    setOrganizationManagers(
      organization_id: $organization_id
      user_ids: $user_ids
      is_manager: $is_manager
    )
  }
`;

export const CREATE_ORGANIZATION_MANAGER = gql`
  mutation CreateOrganizationManager($organization_id: ID!, $input: OrgManagerInput!) {
    createOrganizationManager(organization_id: $organization_id, input: $input) {
      id
      full_name
      email
      organization {
        id
        name
      }
    }
  }
`;
